import { TYPES } from "./time_tracking.type";

const initState = {
  all: null,
  date: null,
};

const timeReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SELECT_ALL_TRACKING_SUCCESS:
      return {
        ...state,
        all: payload,
      };

    case TYPES.SELECT_DATE_TRACKING_SUCCESS:
      return {
        ...state,
        date: payload,
      };

    default:
      return state;
  }
};

export default timeReducer;
